export default __webpack_public_path__ + "static/media/headsupguys.3a0d32d0.png";